import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "../../axios";
import { Link, useNavigate } from "react-router-dom";

const EventList = () => {
  const [events, setEvents] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const handleEdit = (id) => {
    // console.log("Edit event:", id);
    // You can redirect to edit page like:
    // window.location.href = `/admin/addEvent/${id}`;
    navigate(`/admin/addEvent/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this event?")) {
      axios
        .delete(`/events/${id}`)
        .then(() => {
          const updated = events.filter((event) => event.id !== id);
          setEvents(updated);
          setFilteredData(updated);
        })
        .catch((err) => {
          console.error("Error deleting event:", err);
        });
    }
  };
  useEffect(() => {
    let isMounted = true;

    axios
      .get("/events")
      .then((res) => {
        if (isMounted) {
          setEvents(res.data);
          setFilteredData(res.data);
          // console.log("Event data fetched");
        }
      })
      .catch((err) => {
        console.error("Failed to fetch events:", err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const filtered = events.filter((event) =>
      event.title.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchText, events]);
  // console.log("API Base URL:", process.env.REACT_APP_API_URL);

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "100px",
      cell: (row, index) => <div className="text-center">{index + 1}</div>,
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },

    {
      name: "Location",
      selector: (row) => row.location,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="action-buttons justify-content-center">
          <button
            className="edit-btn"
            onClick={() => handleEdit(row.id)}
            title="Edit">
            <i className="bi bi-pencil"></i>
          </button>
          <button
            className="delete-btn"
            onClick={() => handleDelete(row.id)}
            title="Delete">
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      width: "150px",
    },
  ];

  return (
    <div className="main-content">
      <div className="page-header">
        <h4>Events</h4>
        <Link to="/admin/addEvent" className="text-decoration-none">
          <button className="gold-add-btn text-white">+ Add Event</button>
        </Link>
      </div>

      <input
        type="text"
        className="search-input my-4"
        placeholder="Search events..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <div className="data-table-container">
        <DataTable
          columns={columns}
          data={searchText ? filteredData : events}
          pagination
          paginationPerPage={10}
          highlightOnHover
          responsive
          className="data-table"
          persistTableHead={true}
          noDataComponent={
            <div className="text-center py-4">No events found</div>
          }
        />
      </div>
    </div>
  );
};

export default EventList;
